<template>
  <div :class="b()" @mouseleave="onMouseLeave()">
    <div
      v-for="(item, index) in itemsInternal"
      :key="index"
      :class="
        b('item', {
          visible: item.visible,
          rendered: item.rendered,
          priority: item.priority,
        })
      "
      @mouseenter="onItemMouseEnter(index)"
    >
      <keep-alive>
        <div v-if="item.rendered" :class="b('item-content')">
          <slot
            name="item"
            :item="item"
            :index="index"
            :visible="item.visible"
            :hovered="isHovered(index)"
            :on-load="() => onItemLoad(index)"
          />
        </div>
      </keep-alive>
    </div>
  </div>
</template>

<script src="./scripts.js" />

<style module src="./styles.scss" lang="scss" />
